import { getRoutes } from "@/api/role";
import { constantRoutes } from "@/router";
import Layout from "@/layout/index.vue";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

const loadView = (view) => {
  // 路由懒加载
  return () => import(`@/views/${view}`);
};

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp) || roles.includes("admin")) {
      if (tmp.component == "Layout") {
        tmp.component = Layout;
      } else {
        tmp.component = loadView(tmp.component);
      }
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, { roles, asyncRoutes }) {
    const toolPageRedirect = ["serianum-fireware-manage", "firmware-upgrade"];
    const dispenserRedirect = ["serial-num-tool","id-tool","serial-num-tool-ultra"];
    return new Promise((resolve) => {
      if (process.env.VUE_APP_IS_SOFTWARE == "false") {
        asyncRoutes.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((v) => {
              //序列号工具页面区分
              if (
                toolPageRedirect.find((v1) => v.component.indexOf(v1) != -1)
              ) {
                v.component = "tool/serianum-fireware-manage-web.vue";
                console.log("tool页面屏蔽：", v.name);
              }
              // 喂药器序列号页区分
              if (
                dispenserRedirect.find((v1) => v.component.indexOf(v1) != -1)
              ) {
                v.component = "dispenser/serial-num-tool-web.vue";
                console.log("喂药器序列号烧录屏蔽：", v.name);
              }
            });
          }
        });
      }

      let accessedRoutes;
      if (roles.includes("admin")) {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, ["admin"]);
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      }

      accessedRoutes.push({ path: "*", redirect: "/404", hidden: true });
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
